import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { itemPerPage, pageMaxSize } from '../baseUrls/consts';
import { InputNumber } from 'primereact/inputnumber';
import DemandeService from '../services/DemandeService';
import LieuService from '../services/LieuService';
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown';
import { TabView, TabPanel } from 'primereact/tabview';
import { Steps } from 'primereact/steps';
import { Toast } from 'primereact/toast'
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import VehiculeService from '../services/VehiculeService';
import CvaService from '../services/CvaService';
import ReponseService from '../services/ReponseService';
import { FilterMatchMode, FilterOperator } from 'primereact/api';

import CurrentUserService from '../services/CurrentUserService';
import { EtatDemandeEnums} from '../enums/EtatDemandeEnums'
import {TypeUtilisateurEnums} from '../enums/TypeUtilisateurEnums'


const Traitement = () => {
    const [yesNo, setYesNo] = useState({});
    const [chefParcForm, setChefParcForm] = useState({});
    const [responsableStructureForm, setResponsableStructureForm] = useState({});
    const [readOnlyForm, setReadOnlyForm] = useState({});

    return (
        <div>
            <div className="card">
                <Table {...{ setChefParcForm, setResponsableStructureForm, setReadOnlyForm, setYesNo }} />
                <ChefParcForm {...{ chefParcForm, setYesNo }} />
                <ResponsableStructureForm {...{ responsableStructureForm, setYesNo }} />
                <ReadOnlyForm {...{ readOnlyForm, setYesNo }} />
                <Confirmation {...yesNo} />
            </div>

        </div>
    );
}

const Table = (props) => {
    const [items, setItems] = useState([]);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(true);
    const {setChefParcForm, setResponsableStructureForm, setReadOnlyForm, setYesNo} = props;
    const [activeIndex, setActiveIndex] = useState(0);
    //const [filters1, setFilters1] = useState(null);

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    const currentUser = CurrentUserService.get();
    const currentUserType = CurrentUserService.getType();

    let activeIndex2Title = null;
    if(TypeUtilisateurEnums.RESPONSABLE_STRUCTURE) activeIndex2Title = "Demandes approuvées";
    if(TypeUtilisateurEnums.CHEF_PARC) activeIndex2Title = "Demandes acceptées";
    
    useEffect(() => {
        loadItems();
        //initFilters1();
    }, [activeIndex]);
    
    const loadItems = () => {

        let requeteEtat = null;

        if(activeIndex === 0 && currentUserType === TypeUtilisateurEnums.RESPONSABLE_STRUCTURE) requeteEtat = EtatDemandeEnums.INITIEE;
        if(activeIndex === 1 && currentUserType === TypeUtilisateurEnums.RESPONSABLE_STRUCTURE) requeteEtat = EtatDemandeEnums.APPROUVEE;

        if(activeIndex === 0 && currentUserType === TypeUtilisateurEnums.CHEF_PARC) requeteEtat = EtatDemandeEnums.APPROUVEE;
        if(activeIndex === 1 && currentUserType === TypeUtilisateurEnums.CHEF_PARC) requeteEtat = EtatDemandeEnums.ACCEPTEE;
        
        if(activeIndex === 2) requeteEtat = EtatDemandeEnums.REJETEE;

        let requeteEntite = null;
        if(currentUserType === TypeUtilisateurEnums.RESPONSABLE_STRUCTURE) requeteEntite = {structureId : currentUser.structure.id}
        if(currentUserType === TypeUtilisateurEnums.CHEF_PARC) requeteEntite = {institutionId : currentUser.structure.institution.id}

        setLoading(true);
        let onResponse = (data, status) => {
            setLoading(false);
            console.log(data);
            if (status) setItems(data);
            
        };
        DemandeService.get(onResponse, { etatDemande: requeteEtat, ...requeteEntite, size: itemPerPage });
    }
    
    const processDemandeDetailsEtAccepte = (item) => {
        setChefParcForm({
            visible: true,
            hide: () => setChefParcForm((prev) => ({ ...prev, visible: false })),
            data: item,
            setData: (data) => setChefParcForm((prev) => ({ ...prev, data })),
            callback: () => {
                setLoading(true);
                loadItems();
            }
        })
    }

    const processDemandeDetailsEtApprouve = (item) => {
        setResponsableStructureForm({
            visible: true,
            hide: () => setResponsableStructureForm((prev) => ({ ...prev, visible: false })),
            data: item,
            setData: (data) => setResponsableStructureForm((prev) => ({ ...prev, data })),
            callback: () => {
                setLoading(true);
                loadItems();
            }
        })
    }

    const showReponse = (item) => {
        setReadOnlyForm({
            visible: true,
            hide: () => setReadOnlyForm((prev) => ({ ...prev, visible: false })),
            data: item,
            setData: (data) => setReadOnlyForm((prev) => ({ ...prev, data })),
            callback: () => {
                setLoading(true);
                loadItems();
            }
        })
    }

    /*
    const initFilters1 = () => {
        setFilters1({
            'etatDemande': { operator: FilterOperator.AND, 
                constraints: [{ value: 'INITIEE', matchMode: FilterMatchMode.EQUALS }] },
        });
    }
    */

    const table = (
        <DataTable dataKey="id" value={items}
            paginator rows={itemPerPage} /*first={first}  
            totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}*/
            //filters={filters1}
            loading={loading} globalFilter={globalFilter}
            responsiveLayout="scroll" emptyMessage="Aucune donnée disponible.">

            <Column field="id" header="Identifiant" sortable hidden />
            {/* <Column field="dateDemande" header="Date de demande" sortable 
                    body={(item)=> new Date(item.dateDemande).toLocaleDateString()}/> */}
            <Column field="utilisateur.nom" header="Demandeur" sortable body={(selectedItem) =>
                selectedItem.utilisateur && (selectedItem.utilisateur.nom + " "
                    + selectedItem.utilisateur.prenom)
            } />
            <Column field="lieuxActivite" header="Lieu" sortable 
                body={(item) => item.lieuxActivite.map((lieu) => lieu.libelle).join(', ')}/>
            {/* <Column field="nbreParticipant" header="Nombre de participants" sortable /> */}
            <Column field="nbreVehicule" header="Nombre de véhicules" sortable style={{ fontWeight: 'bold' }} />
            <Column field="dateDebutActivite" header="Date début de l'activité" sortable
                body={(item) => new Date(item.dateDebutActivite).toLocaleDateString()} />
            <Column field="dateFinActivite" header="Date fin de l'activité" sortable
                body={(item) => new Date(item.dateFinActivite).toLocaleDateString()} />

            <Column field="etatDemande" header="Etat" sortable body={(item) =>
                <span className={`customer-badge status-${item.etatDemande === 'ACCEPTEE'
                    ? 'qualified'
                    : (item.etatDemande === 'APPROUVEE' ? 'new'
                        : item.etatDemande === 'REJETEE' ? 'unqualified' : 'proposal')}`}>
                    {item.etatDemande}
                </span>
            } />
            {activeIndex === 0 
            ?   <Column body={(selectedItem) =>
                    <div className="flex justify-content-end">
                        {currentUserType === TypeUtilisateurEnums.CHEF_PARC &&
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-success mr-2"
                            onClick={() => processDemandeDetailsEtAccepte(selectedItem)} />
                        }
                        {currentUserType === TypeUtilisateurEnums.RESPONSABLE_STRUCTURE &&
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-success mr-2"
                            onClick={() => processDemandeDetailsEtApprouve(selectedItem)} />
                        }
                    </div>
                } />
            :   <Column body={(selectedItem) =>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-eye" className="p-button-rounded p-button-success mr-2"
                            onClick={() => showReponse(selectedItem)} />
                    </div>
                } />
            }    
        </DataTable>
    );
    
    return (
        <>
            <h5>Liste des demandes</h5>
            <Toolbar className="mb-4"
                left={
                    <>
                        <div className="my-2">
                            <Button label="Actualiser" icon="pi pi-refresh" className="p-button-primry mr-2" 
                                onClick={()=>{setLoading(true); loadItems()}} />
                        </div>
                    </>
                }
                right={
                    <React.Fragment>
                        <span className="block mt-2 md:mt-0 p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText type="search" placeholder="Recherche..."
                                onInput={(e) => setGlobalFilter(e.target.value)} />
                        </span>
                    </React.Fragment>
                } />

            <TabView activeIndex={activeIndex} onTabChange={(e) => { setActiveIndex(e.index);/* alert(e.index)*/ }} >
                <TabPanel header="Demandes en traitement">{table}</TabPanel>
                <TabPanel header={activeIndex2Title}>{table}</TabPanel>
                <TabPanel header="Demandes rejetées">{table}</TabPanel>
            </TabView>
        </>
    );
}

const ChefParcForm = (props) => {
    const { visible, hide, data, setData, callback } = props.chefParcForm;
    const { setYesNo } = props;
    const history = useHistory();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    
    const [vehicules, setVehicules] = useState([]);
    const [chauffeurs, setChauffeurs] = useState([]);

    const [selectedCoupleVehiculeChauffeur, setSelectedCoupleVehiculeChauffeur] = useState();
    const [coupleVehiculeChauffeurs, setCoupleVehiculeChauffeurs] = useState([]);
    const [observation, setObservation] = useState();

    const [acceptanceScreen, onAcceptanceScreen] = useState(false);

    useEffect(() => {
        if (!visible) return;
        loadVehicules();
        loadChauffeurs();
        setCoupleVehiculeChauffeurs([]);
        //
        setActiveIndex(0);
        history.replace("/traitement")
        //
    }, [visible])

    const loadVehicules = () => {
        VehiculeService.getDisponible((data)=> data && setVehicules(data), {demandeVehiculeId: data.id})
    }
    const loadChauffeurs = ()=>{
        CvaService.getDisponible((data)=> data && setChauffeurs(data), {demandeVehiculeId: data.id})
    }

    const goBack = (e) => {
        if (activeIndex === 1) {
            setActiveIndex(0);
            history.replace("/traitement")
        } else {
            hide(e);
        }
    }

    const goNext = (e) => {
        if (activeIndex !== 1) {
            setActiveIndex(1);
            onAcceptanceScreen(true);
            history.replace("/traitement/step2")
            return true;
        }
        return false;
    }

    const goNext2 = (e)=>{
        if (activeIndex !== 1) {
            setActiveIndex(1);
            onAcceptanceScreen(false);
            history.replace("/traitement/step3")
        }
    }

    const addChoice = ()=>{
        if(!selectedCoupleVehiculeChauffeur) return;
        let items = [...coupleVehiculeChauffeurs, ...[selectedCoupleVehiculeChauffeur]];
        setCoupleVehiculeChauffeurs(items);
        setSelectedCoupleVehiculeChauffeur(null);
    }

    const removeSelectedCoupleVehiculeChauffeur = (selectedCoupleVehiculeChauffeur)=> {
        let index = coupleVehiculeChauffeurs.indexOf(selectedCoupleVehiculeChauffeur);
        coupleVehiculeChauffeurs.splice(index, 1);
        setCoupleVehiculeChauffeurs([...coupleVehiculeChauffeurs]);
    }

    const submit = (e) => {
        if(goNext()) return;
        let payload;
        if(acceptanceScreen) {
            let tmpCoupleVehiculeChauffeurs = coupleVehiculeChauffeurs
                .map(item=> ({cvaId: item.chauffeur.id, vehiculeId: item.vehicule.id}));

            payload = {demandeVehiculeId: data.id, coupleVehiculeCva: tmpCoupleVehiculeChauffeurs};    
        }
        //console.log(JSON.stringify(payload, null, 2))
        setYesNo(
            {
                visible: true,
                message : "Confirmez-vous l'ajout ?",
                hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                callback : ()=> {
                    setLoading(true);
                    let onResponse = (data, status)=> {
                            setLoading(false);
                            if(!status) return;
                            hide();
                            callback();
                    }
                    if(acceptanceScreen) ReponseService.save(payload, onResponse); 
                    else DemandeService.updateEtat(onResponse, {demandeId: data.id, nouvelEtat: "REJETEE", observation: observation})
                }
            }
        )
    }

    const displayValues = data?.lieuxActivite?.map((lieu) => lieu.libelle).join(', ');

    const step1Form = (
        <div className='p-fluid'>
            <div className="field" hidden>
                <label htmlFor="id">Identifiant</label>
                <InputText id="id" value={data?.id} />
            </div>
            <div className="field" >
                <label htmlFor="dateDemande">Date de demande</label>
                <Calendar id="dateDemande" value={data && new Date(data.dateDemande)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
            </div>
            <div className="field" >
                <label htmlFor="lieuxActivite">Lieux</label>
                <InputText id="lieuxActivite" value={displayValues} readOnly />
            </div>
            <div className="field">
                <label htmlFor="nbreParticipant">Nombre de participants</label>
                <InputNumber id="nbreParticipant" value={data?.nbreParticipant} 
                    required readOnly />
            </div>
            <div className="field">
                <label htmlFor="nbreVehicule">Nombre de véhicules</label>
                <InputNumber id="nbreVehicule" value={data?.nbreVehicule} readOnly/>
            </div>
            <div className="field">
                <label htmlFor="dateDebutActivite">Date début de l'activité</label>
                <Calendar id="dateDebutActivite" value={data && new Date(data.dateDebutActivite)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
                    
            </div>
            <div className="field">
                <label htmlFor="dateFinActivite">Date fin de l'activité</label>
                <Calendar id="dateFinActivite" value={data && new Date(data.dateFinActivite)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
            </div>
        </div>
    )

    const step2Form = (
        <div className='p-fluid'>
           <div className="field">
                <label htmlFor="immatriculation">Véhicules</label>
                <Dropdown id="vehicule" onChange={(e)=> {setSelectedCoupleVehiculeChauffeur({...selectedCoupleVehiculeChauffeur, vehicule: e.value})}}
                    placeholder="Aucune sélection"
                    options={vehicules}
                    value={selectedCoupleVehiculeChauffeur?.vehicule}
                    optionLabel="immatriculation" />
            </div>
            <div className="field">
                <label htmlFor="chauffeur">Chauffeurs</label>
                <Dropdown id="chauffeur" onChange={(e)=> {setSelectedCoupleVehiculeChauffeur({...selectedCoupleVehiculeChauffeur, chauffeur: e.value})}}
                    placeholder="Aucune sélection"
                    options={chauffeurs} 
                    value={selectedCoupleVehiculeChauffeur?.chauffeur}
                    optionLabel={(data)=> data.nom + " " + data.prenom} />
            </div>
            <div className="field">
                <Button label="Ajouter" className="my-2" onClick={addChoice} />
            </div>
    
            <DataTable dataKey="id" value={coupleVehiculeChauffeurs} responsiveLayout="scroll" 
                paginator rows={10}>
                <Column field="vehicule.immatriculation" header="Immatriculation"></Column>
                <Column field="vehicule.marque" header="Marque"></Column>
                <Column field="vehicule.nbrePlace" header="Nombre de places"></Column>
                <Column header="Chauffeur" body={(item)=> item.chauffeur.nom + " " + item.chauffeur.prenom}></Column>
                <Column body={ (selectedItem)=>
                    <div className="flex justify-content-end">
                        <Button icon="pi pi-trash" className="p-button-rounded p-button-warning mr-2" 
                            onClick={()=> removeSelectedCoupleVehiculeChauffeur(selectedItem)} />
                    </div>
                } />   
            </DataTable>
        </div>
    )
    
    const step3Form = (
        <div className='p-fluid'>
            <div className="field" >
                <label htmlFor="observation">Observation</label>
                <InputTextarea id="observation" value={observation} onChange={(e)=>setObservation(e.target.value)} autoResize autoFocus required />
            </div>
        </div>
    )
    
    return (
        <Dialog visible={visible} style={{ width: '800px' }} modal className="p-fluid"
            header={
                <div className='flex flex-row align-items-center'>
                    <Button icon="pi pi-arrow-left" className="p-button-rounded p-button-text mr-2"
                        onClick={goBack} />
                    <h5 className='m-0'>Traitement demande</h5>
                </div>
            }
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide} />
                    {activeIndex === 0 &&
                        <Button icon="pi pi-ban" className="p-button-danger p-button-text" 
                            label={ "Rejeter" }
                            onClick={goNext2}  
                            />
                    }
                    <Button className="p-button-text" loading={loading}
                        label={activeIndex === 1 ? "Terminer" : "Continuer"}
                        icon={`pi pi-${activeIndex === 1 ? "check" : "angle-right"}`}
                        iconPos={`${activeIndex === 1 ? "left" : "right"}`}
                        onClick={submit} />
                </>
            }
            onHide={hide} >

            <Steps className='mt-1'
                model={[
                    { label: 'Détails demande', command: () => history.push('/traitement') },
                    { 
                        label: `${location.pathname === "/traitement/step3" ? "Observation" : 'Ajout véhicules'}`, 
                        command: () => history.push('/traitement/step2') 
                    }
                ]}
                activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} 
                />
            
            <Route path={'/traitement'} exact render={() => <div className='mt-5'>{step1Form}</div>} />
            <Route path={'/traitement/step2'} render={() => <div className='mt-5'>{step2Form}</div>} />
            <Route path={'/traitement/step3'} render={() => <div className='mt-5'>{step3Form}</div>} />

        </Dialog>
    )
}


const ResponsableStructureForm = (props) => {
    const { visible, hide, data, setData, callback } = props.responsableStructureForm;
    const { setYesNo } = props;
    const history = useHistory();
    const location = useLocation();

    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    
    const [observation, setObservation] = useState();

    const displayValues = data?.lieuxActivite?.map((lieu) => lieu.libelle).join(', ');

    useEffect(() => {
        if (!visible) return;
        //
        setActiveIndex(0);
        history.replace("/traitement")
    }, [visible])

    const goBack = (e) => {
        if (activeIndex === 1) {
            setActiveIndex(0);
            history.replace("/traitement")
        } else {
            hide(e);
        }
    }

    const goNext2 = (e)=>{
        if (activeIndex !== 1) {
            setActiveIndex(1);
            history.replace("/traitement/step2")
        }
    }

    const submit = (e) => {

        //Demande approuvée
        if(activeIndex == 0) {
            setYesNo(
                {
                    visible: true,
                    message : "Confirmez-vous l'approbation ?",
                    hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                    callback : ()=> {
                        setLoading(true);
                        let onResponse = (data, status)=> {
                                setLoading(false);
                                if(!status) return;
                                hide();
                                callback();
                        }
                        DemandeService.updateEtat(onResponse, {demandeId: data.id, nouvelEtat: "APPROUVEE", observation: observation})
                    }
                }
            )
        }

        //Demande rejetée
        if(activeIndex == 1) {
            setYesNo(
                {
                    visible: true,
                    message : "Confirmez-vous le rejet ?",
                    hide: ()=> setYesNo((prev)=>({...prev, visible: false})),
                    callback : ()=> {
                        setLoading(true);
                        let onResponse = (data, status)=> {
                                setLoading(false);
                                if(!status) return;
                                hide();
                                callback();
                        }
                        DemandeService.updateEtat(onResponse, {demandeId: data.id, nouvelEtat: "REJETEE", observation: observation})
                    }
                }
            )
        }        
    }


    const step1Form = (
        <div className='p-fluid'>
            <div className="field" hidden>
                <label htmlFor="id">Identifiant</label>
                <InputText id="id" value={data?.id} />
            </div>
            <div className="field" >
                <label htmlFor="dateDemande">Date de demande</label>
                <Calendar id="dateDemande" value={data && new Date(data.dateDemande)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
            </div>
            <div className="field" >
                <label htmlFor="lieuxActivite">Lieu</label>
                <InputText id="lieuxActivite" value={displayValues} readOnly />
            </div>
            <div className="field">
                <label htmlFor="nbreParticipant">Nombre de participants</label>
                <InputNumber id="nbreParticipant" value={data?.nbreParticipant} 
                    required readOnly />
            </div>
            <div className="field">
                <label htmlFor="nbreVehicule">Nombre de véhicules</label>
                <InputNumber id="nbreVehicule" value={data?.nbreVehicule} readOnly/>
            </div>
            <div className="field">
                <label htmlFor="dateDebutActivite">Date début de l'activité</label>
                <Calendar id="dateDebutActivite" value={data && new Date(data.dateDebutActivite)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
                    
            </div>
            <div className="field">
                <label htmlFor="dateFinActivite">Date fin de l'activité</label>
                <Calendar id="dateFinActivite" value={data && new Date(data.dateFinActivite)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
            </div>
        </div>
    )

    const step2Form = (
        <div className='p-fluid'>
            <div className="field" >
                <label htmlFor="observation">Observation</label>
                <InputTextarea id="observation" value={observation} onChange={(e)=>setObservation(e.target.value)} autoResize autoFocus required />
            </div>
        </div>
    )
    
    return (
        <Dialog visible={visible} style={{ width: '800px' }} modal className="p-fluid"
            header={
                <div className='flex flex-row align-items-center'>
                    <Button icon="pi pi-arrow-left" className="p-button-rounded p-button-text mr-2"
                        onClick={goBack} />
                    <h5 className='m-0'>Traitement demande</h5>
                </div>
            }
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide} />
                    {activeIndex === 0 &&
                        <Button icon="pi pi-ban" className="p-button-danger p-button-text" 
                            label={ "Rejeter" }
                            onClick={goNext2}  
                            />
                    }
                    <Button className="p-button-text" loading={loading}
                        label={activeIndex === 1 ? "Terminer" : "Approuver"}
                        icon="pi pi-check"
                        onClick={submit} />
                </>
            }
            onHide={hide} >

            <Steps className='mt-1'
                model={[
                    { label: 'Détails demande', command: () => history.push('/traitement') },
                    { 
                        label: "Observation", 
                        command: () => history.push('/traitement/step2') 
                    }
                ]}
                activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} 
                />
            
            <Route path={'/traitement'} exact render={() => <div className='mt-5'>{step1Form}</div>} />
            <Route path={'/traitement/step2'} render={() => <div className='mt-5'>{step2Form}</div>} />

        </Dialog>
    )
}


const ReadOnlyForm = (props) => {
    const { visible, hide, data, setData, readOnly, callback } = props.readOnlyForm;
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [stepCount, setStepCount] = useState(0);
    
    const [coupleVehiculeChauffeurs, setCoupleVehiculeChauffeurs] = useState([]);
    const [observation, setObservation] = useState();

    const displayValues = data?.lieuxActivite?.map((lieu) => lieu.libelle).join(', ');

    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(itemPerPage);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };

    useEffect(() => {
        if (!visible) return;
        setCoupleVehiculeChauffeurs([]);
        //
        computeStepCount();
        setActiveIndex(0);
        history.replace("/traitement")
        //
        setCoupleVehiculeChauffeurs(data.reponses.map(couple=>({vehicule: couple.vehicule, chauffeur: couple.cva})))
        setObservation(data.observation)

        /*
        const i =2;
        const test = [
            { label: 'Détails demande'},
            ...[(i === 1) && {label: "label" }]
        ]
        alert(JSON.stringify(test, null, 2))
        */
    }, [visible])

    const goBack = (e) => {
        if (activeIndex > 0) {
            setActiveIndex(activeIndex -1);
            history.replace("/traitement")
        } else {
            hide(e);
        }
    }

    const goNext = (e) => {
        if (activeIndex !== (stepCount -1)) {
            setActiveIndex(1);
            history.replace("/traitement/step2")
        }else{
            hide(e);
        }
    }

    const computeStepCount = () => {
        if(!data) return;
        if(data.etatDemande === 'INITIEE' || data.etatDemande === 'APPROUVEE')
            setStepCount(1);
        else
            setStepCount(2);
    }

    const step1Form = data && (
        <div className='p-fluid'>
            <div className="field" hidden>
                <label htmlFor="id">Identifiant</label>
                <InputText id="id" value={data?.id} />
            </div>
            <div className="field" >
                <label htmlFor="dateDemande">Date de demande</label>
                <Calendar id="dateDemande" value={data && new Date(data.dateDemande)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
            </div>
            <div className="field" >
                <label htmlFor="lieuxActivite">Lieux</label>
                <InputText id="lieuxActivite" value={displayValues} readOnly />
            </div>
            <div className="field">
                <label htmlFor="nbreParticipant">Nombre de participants</label>
                <InputNumber id="nbreParticipant" value={data?.nbreParticipant} 
                    required readOnly />
            </div>
            <div className="field">
                <label htmlFor="nbreVehicule">Nombre de véhicules</label>
                <InputNumber id="nbreVehicule" value={data?.nbreVehicule} readOnly/>
            </div>
            <div className="field">
                <label htmlFor="dateDebutActivite">Date début de l'activité</label>
                <Calendar id="dateDebutActivite" value={data && new Date(data.dateDebutActivite)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
                    
            </div>
            <div className="field">
                <label htmlFor="dateFinActivite">Date fin de l'activité</label>
                <Calendar id="dateFinActivite" value={data && new Date(data.dateFinActivite)} 
                    mask="99/99/9999" readOnlyInput showOnFocus={false} />
            </div>
        </div>
    )

    const step2Form = data && (
        <div className='p-fluid'>
            {data.etatDemande === 'ACCEPTEE' &&
                <DataTable dataKey="id" value={coupleVehiculeChauffeurs} responsiveLayout="scroll" 
                    paginator rows={rows} first={first}  
                    totalRecords={120} rowsPerPageOptions={[5, 10, 20, 30]} onPageChange={onPageChange}>
                    <Column field="vehicule.immatriculation" header="Immatriculation"></Column>
                    <Column field="vehicule.marque" header="Marque"></Column>
                    <Column field="vehicule.nbrePlace" header="Nombre de places"></Column>
                    <Column header="Chauffeur" body={(item)=> item.chauffeur.nom + " " + item.chauffeur.prenom}></Column>   
                </DataTable> 
            }
            {data.etatDemande === 'REJETEE' &&
               <div className='p-fluid'>
                    <div className="field" >
                        <label htmlFor="observation">Observation</label>
                        <InputTextarea id="observation" value={observation} onChange={(e)=>setObservation(e.target.value)} 
                            readOnly autoResize autoFocus required />
                    </div>
                </div>
            }
        </div>
    )
    
    return ( !data ? null :
        <Dialog visible={visible} style={{ width: '800px' }} modal className="p-fluid"
            header={
                <div className='flex flex-row align-items-center'>
                    <Button icon="pi pi-arrow-left" className="p-button-rounded p-button-text mr-2"
                        onClick={goBack} />
                    <h5 className='m-0'>Traitement demande</h5>
                </div>
            }
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide} />
                    <Button className="p-button-text" loading={loading}
                        label={activeIndex === (stepCount-1) ? "Terminer" : "Continuer"}
                        icon={`pi pi-${activeIndex === (stepCount-1) ? "check" : "angle-right"}`}
                        iconPos={`${activeIndex === (stepCount-1) ? "left" : "right"}`}
                        onClick={goNext} />
                </>
            }
            onHide={hide} >

            <Steps className='mt-1'
                model={[
                    { label: 'Détails demande', command: () => history.push('/traitement') },
                    { ...(stepCount > 1) && 
                        {
                            label: `${data.etatDemande === 'REJETEE' ? "Observation" : 'Véhicules'}`, 
                            command: () => history.push('/traitement/step2') 
                        }
                    }
                ]}
                activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} 
                />
            
            <Route path={'/traitement'} exact render={() => <div className='mt-5'>{step1Form}</div>} />
            <Route path={'/traitement/step2'} render={() => <div className='mt-5'>{step2Form}</div>} />
            
        </Dialog>
    )
}

const Confirmation = (props) => {
    const { visible, hide, message, callback } = props;

    return (
        <Dialog modal visible={visible} onHide={hide}
            header="Confirmation" style={{ width: '350px' }}
            footer={
                <>
                    <Button type="button" label="Non" icon="pi pi-times"
                        onClick={hide}
                        className="p-button-text" />
                    <Button type="button" label="Oui" icon="pi pi-check"
                        onClick={() => { hide(); callback() }}
                        className="p-button-text" autoFocus />
                </>
            }>
            <div className="flex align-items-center justify-content-center">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                <span>{message != null ? message : "Voulez-vous continuer ?"}</span>
            </div>
        </Dialog>
    )
}

{/*
return(
        <Dialog visible={visible} style={{ width: '800px' }} header="Détails de la demande" modal className="p-fluid" 
            footer={
                <>
                    <Button label="Annuler" icon="pi pi-times" className="p-button-text" onClick={hide}  />
                    <Button label="Continuer" icon="pi pi-check" className="p-button-text"  loading={loading} />
                    </>
                } 
                onHide={hide}
                >  
    
                <TabView visible={visible} onHide={hide} >
                    <TabPanel header="Demandes initiées" >
                        <DataTable dataKey="id" value={items}>
                            <Column field="utilisateur.nom" header="Demandeur" sortable body= { (selectedItem)=>
                            selectedItem.utilisateur && (selectedItem.utilisateur.nom + " " 
                            + selectedItem.utilisateur.prenom)
                            } />
                            <Column field="etat" sortable body={ (item)=> 
                                <span className={`customer-badge status-${item.etat === 'ACCEPTEE'
                                        ? 'qualified' 
                                        : (item.etat === 'APPROUVEE' ? 'new' 
                                        : item.etat === 'REJETEE' ? 'unqualified' :  'proposal')}`}>
                                    {item.etat}
                                </span>
                            } />
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Demandes approuvées">
                    </TabPanel>
                </TabView>
            </Dialog>    
        )
*/}


export default Traitement;